import { useState } from "react";
import { PageHero } from "@/components/Sections";
import { LeadForm } from "@/components/LeadForm";
import { Reveal } from "@/components/Reveal";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Wrench, CalendarClock, FileText, CheckCircle2 } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=1600";

const prestations = [
  "Entretien et révision", "Diagnostic électronique", "Recherche de panne", "Freinage",
  "Plaquettes et disques", "Vidange", "Embrayage", "Distribution", "Batterie",
  "Démarrage et charge", "Suspension", "Amortisseurs", "Pneumatiques", "Climatisation",
  "Système électrique", "Mécanique générale", "Réparation moteur", "Réparation de transmission",
];

const serviceOptions = [
  "Entretien / Révision", "Vidange", "Freinage", "Distribution", "Embrayage",
  "Climatisation", "Diagnostic électronique", "Pneumatiques", "Recherche de panne", "Autre",
];

export default function Workshop() {
  const [tab, setTab] = useState("rdv");
  return (
    <div data-testid="workshop-page">
      <PageHero
        overline="Atelier / Réparation"
        title="Réparation & entretien automobile — toutes marques"
        subtitle="Une panne ? Un voyant allumé ? Un entretien à prévoir ? AS AUTO prend en charge les véhicules toutes marques."
        image={HERO}
      />

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <Reveal>
          <div className="flex items-center gap-3 mb-8">
            <Wrench className="h-6 w-6 text-[#C5A059]" />
            <h2 className="font-display text-3xl font-bold text-white">Nos prestations</h2>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3">
          {prestations.map((p, i) => (
            <Reveal key={p} delay={(i % 6) * 0.04}>
              <span className="flex items-center gap-3 text-neutral-300 border-b border-white/5 py-2">
                <CheckCircle2 className="h-4 w-4 text-[#C5A059] shrink-0" /> {p}
              </span>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-5 lg:px-8 pb-24">
        <Reveal>
          <div className="bg-[#0f0f0f] border border-white/10 rounded-sm p-8 lg:p-10">
            <Tabs value={tab} onValueChange={setTab}>
              <TabsList className="grid w-full grid-cols-2 bg-[#121212] border border-white/10 mb-8 h-auto">
                <TabsTrigger data-testid="tab-rdv" value="rdv" className="whitespace-normal data-[state=active]:bg-[#C5A059] data-[state=active]:text-black"><CalendarClock className="h-4 w-4 mr-2 shrink-0" /> Prendre rendez-vous</TabsTrigger>
                <TabsTrigger data-testid="tab-devis" value="devis" className="whitespace-normal data-[state=active]:bg-[#C5A059] data-[state=active]:text-black"><FileText className="h-4 w-4 mr-2 shrink-0" /> Demander un devis</TabsTrigger>
              </TabsList>
              <TabsContent value="rdv">
                <LeadForm
                  type="atelier"
                  submitLabel="Demander un rendez-vous"
                  fields={[
                    { name: "vehicle", label: "Véhicule (marque / modèle)", type: "text", placeholder: "Ex : Renault Clio", full: true },
                    { name: "service", label: "Type d'intervention", type: "select", options: serviceOptions },
                    { name: "date", label: "Date souhaitée", type: "text", placeholder: "Ex : semaine prochaine" },
                    { name: "message", label: "Décrivez le problème / symptômes", type: "textarea", full: true },
                  ]}
                />
              </TabsContent>
              <TabsContent value="devis">
                <LeadForm
                  type="devis"
                  submitLabel="Demander un devis"
                  fields={[
                    { name: "vehicle", label: "Véhicule (marque / modèle)", type: "text", placeholder: "Ex : Citroën C3", full: true },
                    { name: "service", label: "Prestation souhaitée", type: "select", options: serviceOptions },
                    { name: "message", label: "Détails de votre demande", type: "textarea", full: true },
                  ]}
                />
              </TabsContent>
            </Tabs>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
